export default "__VITE_ASSET__fSQJvWly__"